const iconGroups = `
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 18 19" fill="none" stroke="rgb(151, 151, 151)" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="5" cy="4" r="2"/>
    <path d="M1 17v-2a4 4 0 0 1 4-4h0a4 4 0 0 1 4 4v2"/>
    <circle cx="14" cy="6" r="2"/>
    <path d="M11 17v-1.5a3 3 0 0 1 3-3h0a3 3 0 0 1 3 3V17"/>
  </svg>
`;

export default iconGroups;
